import { variableSchema } from '../variable-schema';
import { parseStoredValue } from './parse-stored-value';

export const PAGE_SIZE_FROM_DIMENSIONS = '$pageWidth $pageHeight';

export const PAGE_SIZE_PRESETS: Record<string, { width: string; height: string }> = {
  'A4 portrait': { width: '794px', height: '1123px' },
  'A4 landscape': { width: '1123px', height: '794px' },
  'A3 portrait': { width: '1123px', height: '1587px' },
  'A3 landscape': { width: '1587px', height: '1123px' },
  'A5 portrait': { width: '559px', height: '794px' },
  'A5 landscape': { width: '794px', height: '559px' },
  'letter portrait': { width: '816px', height: '1056px' },
  'letter landscape': { width: '1056px', height: '816px' },
  'legal portrait': { width: '816px', height: '1344px' },
  'legal landscape': { width: '1344px', height: '816px' },
};

const dimension = (variables: Record<string, unknown>, key: 'pageWidth' | 'pageHeight'): number => {
  const def = variableSchema.find((v) => v.key === key);
  return def ? Number(parseStoredValue(variables[key], def)) : NaN;
};

export function pageSizeForDimensions(variables: Record<string, unknown>): string {
  const width = dimension(variables, 'pageWidth');
  const height = dimension(variables, 'pageHeight');
  const preset = Object.entries(PAGE_SIZE_PRESETS).find(([, dims]) => parseFloat(dims.width) === width && parseFloat(dims.height) === height);
  return preset ? preset[0] : `${width} × ${height} px`;
}

export function applyPageSizePreset(variables: Record<string, string | null>, preset: string): Record<string, string | null> {
  const dims = PAGE_SIZE_PRESETS[preset];
  if (!dims) return variables;
  const { pageSize: _previous, ...rest } = variables;
  return { ...rest, pageWidth: dims.width, pageHeight: dims.height, pageSize: PAGE_SIZE_FROM_DIMENSIONS };
}
